export const languageStringsSubscriptions = {
  title: "Subscription",
  successPayment: "Payment was successful.",
  successPaymentDescription:
    "Your credits will appear in your account shortly.",
  wantToChangeSubscription: "Are you sure you want to change your subscription ",
  changeFrom: "from ",
  changeTo: " to ",
  subTitle: "Your subscription",
  portableCreditsDescription:
    "These credits do not expire. They are used when your monthly credit limit is exceeded.",
  tarifs: {
    title: "Plans",
    monthly: "Monthly",
    yearly: "Yearly",
    monthlyPeriod: "monthly",
    yearlyPeriod: "yearly",
    freeMonths: "2 months free",
    viewsPerMonth: "pageviews per month",
    trial: "trial version – unlimited",
    creditsRefresh: "Credits will refresh on:",
    creditsExpire: "Credits expire on:",
    subbscription: "Subscription",
    trialVersion: "trial version",
    trialVersionExpires: "Trial version expires",
    cancelSubscription: "Cancel subscription renewal",
    nextPayment: "Next payment will be processed automatically",
    unlimitedVersion: "Unlimited version of the app is active",
    choseSubscription: "Choose a plan",
    to: "To",
    monthlyViews: "monthly pageviews",
    pricesAreFinal: "The listed prices are final.",
    moreViews: "Do your websites get even more pageviews per month?",
    contactUsForCustom: "Contact us for a custom plan.",
    notificationsWithStatistics: "Notifications with traffic statistics",
    notificationsWithLastOrdersAndRegistrations:
      "Last orders and registrations notifications",
    notificationPersonalization: "Notification personalization",
    zboziAndHeureka: "Review notifications from Heureka and Zboží.cz",
    googleRecenze: "Integration with Google Reviews",
    trustPilot: "Integration with Trustpilot",
    logoCancel: "Logo removal",
    customBranding: "Custom branding",
    unlimitedNotifications: "Unlimited notifications",
    unlimitedWebsites: "Unlimited websites",
    onlyOneWebsite: "(only 1 website)",
    activateFreeTrial: "Activate 14-day free trial",
    mostFavorite: "Most popular",
    selected: "Selected",
    notAvailable: "Not available",
    "LITE": {
      title: "LITE",
      priceYearly: "$50",
      priceMonthly: "$5",
    },
    "MEDIUM": {
      title: "MEDIUM", 
      priceYearly: "$200",
      priceMonthly: "$20",
    },
    "UNLIMITED": {
      title: "UNLIMITED",
      priceYearly: "$350",
      priceMonthly: "$35",
    },
    lite: {
      title: "LITE",
      priceYearly: "39 CZK",
      priceMonthly: "47 CZK",
    },
    start: {
      title: "START",
      priceYearly: "247 CZK",
      priceMonthly: "297 CZK",
    },
    standard: {
      title: "STANDARD",
      priceYearly: "457 CZK",
      priceMonthly: "547 CZK",
    },
    premium: {
      title: "PREMIUM",
      priceYearly: "833 CZK",
      priceMonthly: "997 CZK",
    },
  },
};
